/**
 * @generated SignedSource<<f70eab6b818135aa76bf3ca0c5829132>>
 * @relayHash a85065a3ac7625554eef80becb77f854
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a89f2dbe75d0f4b8cb52d86ad120a4976316b03239d4cb3e32dc2aa921170d7a

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AgentStudioAgentQueryInput = {
  includeDraftAgents?: boolean | null;
  includeJiraCodingAgent?: boolean | null;
  name?: string | null;
  onlyEditableAgents?: boolean | null;
  onlyFavouriteAgents?: boolean | null;
  onlyMyAgents?: boolean | null;
  onlyPublishedEditableAgents?: boolean | null;
  onlyPublishedEditableAgentsWithForge?: boolean | null;
  onlyTemplateAgents?: boolean | null;
  onlyUnpublishedAgents?: boolean | null;
  onlyVerifiedAgents?: boolean | null;
};
export type browseAgentsContentQuery$variables = {
  cloudId: string;
  cloudIdString: string;
  enableJiraAgentFields?: boolean | null;
  input?: AgentStudioAgentQueryInput | null;
  product?: string | null;
  skipUserPermissions?: boolean | null;
  workspaceId?: string | null;
};
export type browseAgentsContentQuery$data = {
  readonly atlassianStudio_userSiteContext?: {
    readonly userPermissions?: {
      readonly " $fragmentSpreads": FragmentRefs<"agentVerificationDropdownItem_AtlaskitRovoAgentComponents_userPermissionsRef">;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"browseAgentsContent_AtlassianConversationAssistantAgent">;
};
export type browseAgentsContentQuery = {
  response: browseAgentsContentQuery$data;
  variables: browseAgentsContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudIdString"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "enableJiraAgentFields"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "product"
},
v5 = {
  "defaultValue": true,
  "kind": "LocalArgument",
  "name": "skipUserPermissions"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v7 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudIdString"
},
v8 = {
  "kind": "Variable",
  "name": "input",
  "variableName": "input"
},
v9 = {
  "kind": "Variable",
  "name": "product",
  "variableName": "product"
},
v10 = {
  "kind": "Variable",
  "name": "workspaceId",
  "variableName": "workspaceId"
},
v11 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v12 = [
  (v7/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  },
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/)
],
v13 = {
  "kind": "ScalarField",
  "name": "id"
},
v14 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "browseAgentsContentQuery",
    "selections": [
      {
        "args": [
          (v7/*: any*/),
          {
            "kind": "Variable",
            "name": "cloudIdAsId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "enableJiraAgentFields",
            "variableName": "enableJiraAgentFields"
          },
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "browseAgentsContent_AtlassianConversationAssistantAgent"
      },
      {
        "condition": "skipUserPermissions",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v11/*: any*/),
            "kind": "LinkedField",
            "name": "atlassianStudio_userSiteContext",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "AtlassianStudioUserProductPermissions",
                    "kind": "LinkedField",
                    "name": "userPermissions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "agentVerificationDropdownItem_AtlaskitRovoAgentComponents_userPermissionsRef"
                      }
                    ]
                  }
                ],
                "type": "AtlassianStudioUserSiteContextOutput"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "browseAgentsContentQuery",
    "selections": [
      {
        "args": (v12/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentStudioAgentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentStudioAssistant",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "deactivated"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "description"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "creatorType"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "conversationStarters"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "identityAccountId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "externalConfigReference"
                  },
                  {
                    "kind": "LinkedField",
                    "name": "creator",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      (v13/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "icon"
                  },
                  {
                    "concreteType": "TeamV2",
                    "kind": "LinkedField",
                    "name": "authoringTeam",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "profileUrl"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "displayName"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "smallAvatarImageUrl"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "forgeCreator"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isVerified"
                  },
                  {
                    "condition": "enableJiraAgentFields",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "AgentStudioAgentPermissions",
                        "kind": "LinkedField",
                        "name": "permissions",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "canEdit"
                          }
                        ]
                      },
                      {
                        "args": (v11/*: any*/),
                        "concreteType": "JiraAgentAssignability",
                        "kind": "LinkedField",
                        "name": "jiraAssignability",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "isAssignable"
                          }
                        ]
                      }
                    ]
                  },
                  (v14/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      {
        "args": (v12/*: any*/),
        "filters": [
          "cloudId",
          "input",
          "product",
          "workspaceId"
        ],
        "handle": "connection",
        "key": "paginatedAgentsList_agentStudio_getAgents",
        "kind": "LinkedHandle",
        "name": "agentStudio_getAgents"
      },
      {
        "condition": "skipUserPermissions",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v11/*: any*/),
            "kind": "LinkedField",
            "name": "atlassianStudio_userSiteContext",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "AtlassianStudioUserProductPermissions",
                    "kind": "LinkedField",
                    "name": "userPermissions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "isAbleToGovernAgents"
                      }
                    ]
                  }
                ],
                "type": "AtlassianStudioUserSiteContextOutput"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a89f2dbe75d0f4b8cb52d86ad120a4976316b03239d4cb3e32dc2aa921170d7a",
    "metadata": {},
    "name": "browseAgentsContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8cb98437013120da544d047a17d237b8";

export default node;
